module.exports = __webpack_public_path__ + "img/sponsor-amns-logo.62c13442.jpg";